import { ENDPOINTS } from "../../redux/apiConfig";
// export const handleVerifyGmail = (displayName) => {
//   console.log(displayName);
// //   const url = ENDPOINTS.BS_GMAIL.GMAIL_AUTH;
//    const url = `${ENDPOINTS.BS_GMAIL.GMAIL_AUTH}?displayName=${encodeURIComponent(displayName)}`;

//   const width = 500;
//   const height = 600;

//   const left = window.screenX + (window.outerWidth - width) / 2;
//   const top = window.screenY + (window.outerHeight - height) / 2;

//   window.open(
//     url,
//     "Gmail OAuth",
//     `width=${width},height=${height},left=${left},top=${top}`,
//   );
// };

export const handleVerifyGmail = (displayName, onClose) => {
  const url = `${ENDPOINTS.BS_GMAIL.GMAIL_AUTH}?displayName=${encodeURIComponent(displayName)}`;

  const width = 500;
  const height = 600;

  const left = window.screenX + (window.outerWidth - width) / 2;
  const top = window.screenY + (window.outerHeight - height) / 2;

  const popup = window.open(
    url,
    "Gmail OAuth",
    `width=${width},height=${height},left=${left},top=${top}`
  );

  const timer = setInterval(() => {
    if (popup.closed) {
      clearInterval(timer);

      console.log("Popup closed");

      // Call modal close here
      if (onClose) {
        onClose();
      }
    }
  }, 1000);
};